import { render, staticRenderFns } from "./MarketIndex.vue?vue&type=template&id=7e16fb00&"
import script from "./MarketIndex.vue?vue&type=script&lang=js&"
export * from "./MarketIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports